var map = {
	"./Inter_28pt-Light.woff": "./fonts/Inter_28pt-Light.woff",
	"./Inter_28pt-Light.woff2": "./fonts/Inter_28pt-Light.woff2",
	"./SegmentItalic.woff": "./fonts/SegmentItalic.woff",
	"./SegmentItalic.woff2": "./fonts/SegmentItalic.woff2",
	"./SegmentLight.woff": "./fonts/SegmentLight.woff",
	"./SegmentLight.woff2": "./fonts/SegmentLight.woff2",
	"./SegmentLightItalic.woff": "./fonts/SegmentLightItalic.woff",
	"./SegmentLightItalic.woff2": "./fonts/SegmentLightItalic.woff2",
	"./SegmentMedium.woff": "./fonts/SegmentMedium.woff",
	"./SegmentMedium.woff2": "./fonts/SegmentMedium.woff2",
	"./SegmentRegular.woff": "./fonts/SegmentRegular.woff",
	"./SegmentRegular.woff2": "./fonts/SegmentRegular.woff2",
	"./SegmentSemiBold.woff": "./fonts/SegmentSemiBold.woff",
	"./SegmentSemiBold.woff2": "./fonts/SegmentSemiBold.woff2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./fonts sync recursive ^\\.\\/.*$";